export const unknownToString = (value: unknown): string => {
  if (typeof value === 'string') return value;
  else if (typeof value === 'number') return value.toString();
  return '';
};
